'use client'

import { useEffect } from 'react'

import { usePostHog } from '@posthog/next'

type FlagExposureTrackerProps = {
  flagKey: string
  flagValue: boolean | string | undefined
}

export default function FlagExposureTracker({ flagKey, flagValue }: FlagExposureTrackerProps) {
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) return

    posthog.capture('$feature_flag_called', {
      $feature_flag: flagKey,
      $feature_flag_response: flagValue,
    })
  }, [flagKey, flagValue, posthog])

  return null
}
